import { useMemo, useState } from "react";
import InfoTip from "./InfoTip";
import { money, mixRows, COLORS } from "./metricsMath";

// Ranking horizontal de categorías (todo el año o un mes); las pequeñas se agrupan en "Otras".
export default function ExpenseMixRanking({ mix, rows }) {
  const [scope, setScope] = useState("year");
  const data = useMemo(() => {
    const base = scope === "year"
      ? mix.map((c) => ({ id: c.id, name: c.name, value: c.total_mxn }))
      : Object.entries(rows.find((r) => String(r.month) === scope)?.byCategory || {}).map(([id, v]) => ({ id, name: mix.find((c) => c.id === id)?.name || "Sin categoría", value: v }));
    return mixRows(base.filter((d) => d.value > 0));
  }, [mix, rows, scope]);
  const max = data[0]?.value || 1;
  const withSpend = rows.filter((r) => r.gastos > 0);

  return (
    <section className="border border-zinc-200 bg-white rounded-lg p-5 flex flex-col gap-2 min-w-0" data-testid="expense-mix">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-heading font-bold text-base m-0 inline-flex items-center gap-1.5">Mix de gastos registrados <InfoTip k="expenses" /></h3>
          <p className="text-xs text-zinc-500 m-0 mt-1 leading-relaxed">{scope === "year" ? "Total del año" : "Total del mes"} por categoría, de mayor a menor. Las categorías pequeñas se agrupan en "Otras".</p>
        </div>
        <select value={scope} onChange={(e) => setScope(e.target.value)} className="h-8 text-xs border border-zinc-200 rounded-md px-2 bg-white shrink-0" data-testid="mix-scope">
          <option value="year">Todo el año</option>
          {withSpend.map((r) => <option key={r.month} value={String(r.month)}>{r.mes}</option>)}
        </select>
      </div>
      {data.length === 0 ? (
        <div className="flex-1 min-h-[180px] dotted-bg flex items-center justify-center text-sm text-zinc-400">Sin gastos</div>
      ) : (
        <div className="flex flex-col gap-2 mt-1" data-testid="mix-list">
          {data.map((d) => (
            <div key={d.id} className="grid grid-cols-[minmax(6rem,9rem)_1fr_3.2rem_6.5rem] items-center gap-2 text-xs numeric" data-testid={`mix-row-${d.id}`}>
              <span className="truncate text-zinc-800 font-body" title={d.name}>{d.name}</span>
              <span className="h-3.5 bg-zinc-100 rounded-sm overflow-hidden"><i className="block h-full rounded-sm" style={{ width: `${(d.value / max) * 100}%`, background: d.otro ? COLORS.sin : COLORS.gas }} /></span>
              <span className="text-right text-zinc-500">{Math.round(d.pct * 100)}%</span>
              <span className="text-right font-semibold text-zinc-900">{money(d.value)}</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
